<template>
  <div id="manage-lists">

    <h1>Manage Lists</h1>
    <p class="lead">Lists are used to organize content and generate custom reports on CDP!</p>

    <form @submit.prevent class="form-inline">
      <div class="form-group">
        <input v-model="listTitle" class="form-control" placeholder="Create a new list"/>
      </div><!-- /.form-group -->
      <button @click="createList" class="btn btn-primary"><i class="far fa-plus"></i></button>
    </form>

    <table class="table" v-if="lists.length">
      <thead>
        <tr>
          <th scope="col">Title</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="list in lists">
          <td><router-link :to="{ name: 'List', params: {id: list.id}}" >{{ list.title }}</router-link> ({{ list.posts.length }})</td>
          <th scope="col"><i @click="openEditListModal(list)" class="far fa-pencil clickable" v-b-tooltip.hover title="Edit List"></i> <i @click="deleteList(list.id)" class="fas fa-times-circle" v-b-tooltip.hover title="Delete List"></i></th>
        </tr>
      </tbody>
    </table>

    <!-- Edit list modal -->
    <div class="post-modal" v-if="editListModal == true">
      <div class="post-modal-content">
        <div class="post-modal-header">
          <a @click="closeEditListModal" class="close"><i class="far fa-times"></i></a>
          <p class="lead">Edit List</p>
        </div><!-- /. post-modal-header -->
        <div class="post-modal-body">
          <form @submit.prevent>
            <div class="form-group">
              <label for="listTitleInput">List Title:</label>
              <input v-model="modalListData.title" class="form-control" :placeholder="modalListData.title" id="listTitleInput"/>
            </div><!-- /.form-group -->
          </form>

          <!-- Show your posts in this list -->
          <table class="table" v-if="postsInList.length">
            <thead>
              <tr>
                <th scope="col">Title</th>
                <th scope="col">Remove</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="post in postsInList">
                <td>{{ post.title }}</td>
                <td><i @click="removeFromList(post, modalListData)" class="fas fa-times-circle" v-b-tooltip.hover title="Remove post"></i></td>
              </tr>
            </tbody>
          </table>

        </div><!-- /.post-modal-body -->
        <div class="post-modal-footer">
          <div class="float-right">
            <button @click="updateList(modalListData.id, modalListData.title)" class="btn btn-primary">Save List</button>
          </div><!-- /.float-right -->
        </div><!-- /.post-modal-footer -->
      </div><!-- /.post-modal-content -->
    </div><!-- /.post-modal -->

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  const fb = require('../firebaseConfig.js')

  export default {
    data() {
      return {
        listTitle: '',
        editListModal: false,
        modalListData: {},
        postsInList: [],
        listData: []
      }
    },
    computed: {
      ...mapState(['userProfile', 'currentUser', 'lists'])
    },
    methods: {
      createList() {
        fb.listsCollection.add({
          createdOn: new Date(),
          userId: this.currentUser.uid,
          userName: this.userProfile.name,
          title: this.listTitle,
          posts: []
        }).then(ref => {
          this.listTitle = ''
        }).catch(err => {
          console.log(err)
        })
      },
      deleteList(id) {
        let check = confirm("Are you sure you want to delete this list?");
        if (check == true) {
          fb.listsCollection.doc(id).delete()
        } else {
          return false;
        }
      },
      openEditListModal(list) {
        this.editListModal = true
        this.modalListData = list

        // Watch this list in real time
        fb.listsCollection.doc(list.id).onSnapshot(listDoc => {
          let listInfo = listDoc.data()
          // Prepare an array of posts based on the ids in this list
          let postsArray = []
          for (let i = 0; i < listInfo.posts.length; i++) {
            fb.postsCollection.doc(listInfo.posts[i].id).onSnapshot(doc => {
              let post = doc.data()
              if (post != null) {
                post.id = doc.id
                postsArray.push(post)
              } else {
                postsArray.push({
                  title: '~DELETED POST~',
                  id: listInfo.posts[i].id
                })
              }
            })
          }
          this.postsInList = postsArray
        })
      },
      closeEditListModal() {
        this.editListModal = false
      },
      updateList(id, title) {
        fb.listsCollection.doc(id).update({
          title: title
        }).then(ref => {
          this.listTitle = ''
          this.closeEditListModal()
        }).catch(err => {
          console.log(err)
        })
      },
      setViewMode(viewMode) {
        this.$emit('setViewMode', viewMode)
      },
      removeFromList(post, list) {
        // Build the list posts array
        var listPostsArray = []
        for (var i = 0; i < list.posts.length; i++) {
          if (list.posts[i].id == post.id) {
          } else {
            listPostsArray.push(list.posts[i])
          }
        }
        fb.listsCollection.doc(list.id).update({
          posts: listPostsArray
        }).then(ref => {
        }).catch(err => {
          console.log(err)
        })
      }
    },
    filters: {
      formatDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        return moment(date).fromNow()
      },
      trimLength(val) {
        if (val.length < 200) {
          let regex = /(<([^>]+)>)/ig;
          let cleanVal = val.replace(regex, " ");
          return cleanVal
         }
        let regex = /(<([^>]+)>)/ig;
        let cleanVal = val.replace(regex, " ");
        return `${cleanVal.substring(0, 200)}...`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ManageLists.vue